$.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null) {
       return null;
    }
    return decodeURI(results[1]) || 0;
}

var baseDomain = 'https://store.sony.com.vn';
var apiToken = getCookie('api_token');

const STORE_ID = window.theme.storeId;
const GWX_BASE_URL = window.theme.gwx_base_url;
const GWX_OPEN_PRODUCT_URL = window.theme.gwx_open_product_url;
const pathProxy = 'apps/api';
const pathProxyEc = 'apps/ec-api';

var http = {
  	baseUrl: [baseDomain, 'apps/api'].join('/'),
    baseGWXUrl: [baseDomain, pathProxyEc].join('/'),
    sendReq: function(url, method, content, datakey, pathProxyEc) {
    	var reqOpt = {
            type: method,
          	url: pathProxyEc ? `${[this.baseGWXUrl, url].join('/')}` : `${[this.baseUrl, url].join('/')}`,
            headers: pathProxyEc 
              ? {
                'store_id': STORE_ID,
                'Accept-Language': 'vi-VN',
                }
              : {
                'x-api-key': apiToken,
                'issuer': STORE_ID,
                'Accept-Language': 'vi-VN',
                'datakey': datakey
              },
            contentType: 'application/json; charset=utf-8',
            dataType: 'json'
        };

        if (method.toLowerCase() !== 'get')
            reqOpt['data'] = JSON.stringify(content);

        var def = $.Deferred();
        $.ajax(reqOpt).done(function (res) {
            def.resolve(res);
        }).fail(function (ex) {
            def.resolve(ex);
            console.log(ex);
        }).always(function () {
        });

        return def.promise();
  	},
    get: function (url, datakey, pathProxyEc) {
      	console.log(url);
        return this.sendReq(url, 'get', datakey, pathProxyEc);
    },
    post: function (url, content, datakey) {
        return this.sendReq(url, 'post', content, datakey);
    },
    put: function (url, content, datakey) {
        return this.sendReq(url, 'put', content, datakey);
    },
    delete: function (url, content) {
        return this.sendReq(url, 'delete', content, datakey);
    }
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function setCookie(cname, cvalue, expirationInSecond) {
  const d = new Date()
  
  d.setTime(expirationInSecond * 1000);

  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// Get API Token
async function getAPIToken() {
  if (!apiToken) {
    try {
      const response = await $.ajax({
        method: 'GET',
        url: `${baseDomain}/apps/api/authen/api-token`,
        headers: {
          'issuer': STORE_ID,
          'Accept-Language': 'en-US'
        },
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
      });

      apiToken = response.token;
      setCookie('api_token', apiToken, response.expired - 600);
      return apiToken;
    } catch (err) {
      return Promise.reject(err);
    }
  }
}

async function callAPIWithTokenRefresh (url, method, content, datakey, pathProxyEc) {
  try {
    if (!getCookie('api_token')) {
      await getAPIToken();
    }
    
    const response = await http.sendReq(url, method, content, datakey, pathProxyEc);
    return response;
  } catch (ex) {
    if (ex.status === 401) {
      // Token expired, refresh the token
      try {
        await getAPIToken();
        // Retry the API call with the new token
        return await http.sendReq(url, method, content, datakey, pathProxyEc);
      } catch (err) {
        console.log(err);
        throw err; // Token refresh failed
      }
    } else {
      throw ex; // Other API call failure
    }
  }
}

async function callAPIWithGWXToken (url, method = 'GET', body = null, headers = {}, baseUrl = GWX_BASE_URL) {
  try {
    const options = {
      method,
      credentials: 'include',
      headers: {
        ...headers,
        'ocp-apim-subscription-key': 'f542a39e47924f1aae39b6456958f147',
        store_id: STORE_ID,
        'Content-Type': 'application/json-patch+json'
      },
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(`${baseUrl}/${url}`, options);
    
    // Check if the response status is in the range 200-299
    if (!response.ok) {
      if (response.status === 401 || response.status === 403) {
        const error = new Error("Unauthorized");
        error.statusCode = response.status;
        throw error;
      } else {
        throw new Error(`HTTP error status: ${response.status}`);
      }
    }

    // Parse the JSON response
    const data = await response?.json();

    return data;  // Return the response data

  } catch (error) {
    console.error('Fetch error:', error);
    throw error;  // Rethrow the error for further handling
  }
}

getAPIToken();
